module.exports = ".client-selection {\n  padding: 15px;\n}\n.dropdown-menu {\n\tcursor: pointer;\n}\n"